import { render, staticRenderFns } from "./HumanCapitalAgeAverageInput.vue?vue&type=template&id=d488e482&scoped=true&"
import script from "./HumanCapitalAgeAverageInput.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalAgeAverageInput.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalAgeAverageInput.vue?vue&type=style&index=0&id=d488e482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d488e482",
  null
  
)

export default component.exports